import { useEffect, useState } from 'react';

/**
 * Prevent a value from changing until the specified time has passed.
 *
 * @param {any} value The value to return.
 * @param {number} delay The time in ms to wait before the value can change.
 *
 * @returns {any}
 *
 */

const useDebouncedValue = <Generic>(value: Generic, delay: number): Generic => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timeout);
    };
  }, [value, delay]);

  return debouncedValue;
};

export default useDebouncedValue;
